const ADD_POST = 'ADD_POST';
const UPDATE_NEW_POST_TEXT = 'UPDATE_NEW_POST_TEXT';

let initialState =  {
    posts: [
        {
            id: 10,
            name: "Jessica Day",
            published: "August,01 2022 19:05PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://images.squarespace-cdn.com/content/v1/5a04c1a4cd39c3605382223e/1556582159675-BGD9V435251LOWB1ROR9/Sugar+and+Water+donuts+nyc.jpg?format=1000w",
            message: "I’ll take the strongest drink you have, and also a donuts on the side in case I don’t like it.",
            likeCount: "12"
        },
        {
            id: 9,
            name: "Jessica Day",
            published: "August,02 2022 17:18PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://media.architecturaldigest.com/photos/55e777cccd709ad62e8f35ab/master/w_1600%2Cc_limit/dam-images-daily-2014-10-new-girl-set-design-new-girl-set-design-07.jpg",
            message: "I just wanted to listen to Taylor Swift alone!",
            likeCount: "50"
        },
        {
            id: 8,
            name: "Jessica Day",
            published: "August, 05 2022 9:05AM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://picsum.photos/500/300",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            likeCount: "29"
        },
        {
            id: 7,
            name: "Jessica Day",
            published: "August,24 2022 6:04AM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://i.pinimg.com/originals/1d/bc/2d/1dbc2d388dd75eaff1ebb08511655a1a.jpg",
            message: "Winston vs Ferguson",
            likeCount: "76"
        },
        {
            id: 6,
            name: "Jessica Day",
            published: "September,29 2022 21:12PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://img.buzzfeed.com/buzzfeed-static/static/2021-02/23/23/tmp/9126c7bee75f/tmp-name-2-2876-1614124316-7_dblbig.jpg?resize=1200:*",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            likeCount: "67"
        },
        {
            id: 5,
            name: "Jessica Day",
            published: "October, 02 2022 02:20AM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://images2.alphacoders.com/261/261330.jpg",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            likeCount: "50"
        },
        {
            id: 4,
            name: "Jessica Day",
            published: "October, 03 2022 18:27PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://static01.nyt.com/images/2021/03/04/travel/04travel-central-park-promo/04travel-central-park-promo-videoSixteenByNineJumbo1600.jpg",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            likeCount: "28"
        },
        {
            id: 3,
            name: "Jessica Day",
            published: "October,13 2022 19:24PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            imgRandom: "https://cdn.wallpapersafari.com/36/62/kSvDEp.jpg",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            likeCount: "10"
        },
        {
            id: 2,
            name: "Jessica Day",
            published: "October,15 2022 04:10AM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://cdn.wallpapersafari.com/8/17/WxoDR6.jpg",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            likeCount: "23"
        },
        {
            id: 1,
            name: "Jessica Day",
            published: "October,15 2022 20:10PM",
            imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
            video: "",
            imgRandom: "https://www.pixelstalk.net/wp-content/uploads/images5/Cute-Cloud-Backgrounds-1920x1080-1.jpg",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            likeCount: "26"
        }
    ],
    newPostText: 'Create new post'
}

let date = (new Date()).toString().split(' ').splice(1,3).join(' ');

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_POST: {
            let newPost = {
                id: state.posts.length + 1,
                name: "Jessica Day",
                published: date,
                imgURL: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg",
                imgRandom:"https://t3.ftcdn.net/jpg/02/70/74/54/360_F_270745436_QYxLPstUWiq52e3V5JEAKqxtcoOHKpsa.jpg",
                message: state.newPostText,
                likeCount: 0
            };
            return  {
                ...state,
                posts: [newPost, ...state.posts ],
                newPostText: ''
            };
        }
        case UPDATE_NEW_POST_TEXT: {
            return  {
                ...state,
                newPostText: action.newText
            };
        }
        default:
            return state;
    }
}
export const addPostActionCreator = () => {
    return {
        type: ADD_POST
    }
}
export const updateNewPostTextActionCreator = (text) => {
    return {
        type: UPDATE_NEW_POST_TEXT,
        newText: text
    }
}

export default profileReducer;